import { Color } from './color';
/**
 * -
 */
export const Hyphen = (options, context) => {
    return Color(Object.assign({ colorAttribute: 'stroke', symbol: 'hyphen' }, options), context);
};
Hyphen.props = Object.assign({ defaultMarker: 'hyphen' }, Color.props);
//# sourceMappingURL=hyphen.js.map